import {
  Component,
  OnInit,
  OnDestroy,
  SecurityContext,
  ViewChild,
  ElementRef, AfterViewInit,
  HostListener,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { ExamsService } from '../exams.service';
import { PregnancyService } from '../pregnancy.service';
import { AutotextService } from '../autotext.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoginService } from '../login.service';
import { VideoCaptureService } from '../video-capture.service';
import { VideoClientService } from '../video-client.service';
import { Router } from '@angular/router';
import { TimerService } from '../timer.service';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GalleryService } from '../gallery.service';
import { Location } from '@angular/common';
import { MeasgrowthService } from '../measgrowth.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../language.service';
import { ExamsbarService } from '../examsbar/examsbar.service';
import { MatDialog } from '@angular/material/dialog';
import { BloodTestReferralDialogComponent } from '../blood-test-referral/blood-test-referral-dialog.component';
import { PrescriptionDialogComponent } from '../prescription/prescription-dialog.component';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss'],
  standalone: false,
})
export class ExamComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('videobox') videoElement: ElementRef;
  @ViewChild('imgcanvas') imageCanvas: ElementRef;
  fetuses = 1;
  showSide = false;
  page = 'Pregnancy';
  pat: Patient;
  showPat = false;
  showgallery = false;
  showcharts = false;
  showprint = false;
  showprintopts = true;
  showPrintHistory = false;
  showInbox = false;
  recording = false;
  recordLink: SafeUrl;
  CurrentSR: number;
  CurrentInbox: number;
  vidMinified: boolean;
  videoSource: string;
  audioSource: string;
  Stream: MediaStream;
  soundtest: boolean;
  audioInputs: { value: any; text: any }[];
  videoInputs: { value: any; text: any }[];
  videowarn = false;
  SR: SafeHtml;
  noStop = false;
  showdeleteimg = false;
  exitTimeout;
  fullscreen = false;
  ExamSubscription: Subscription;
  showlink = false;
  sub: Subscription;
  takePicSubsctiption: Subscription;
  phototaken: SafeUrl;
  showTimmer;
  messages: string;
  sendonce = false;
  showSelect = false;
  concentForm;
  inform = false;
  afterdefault: string;
  defaultWarn = false;
  public missingLMPMsg = false;
  showPage$: Subject<string> = new Subject<string>();
  private examDestroy$ = new Subject<void>();
  show_surrogate = false;
  linkedConcent = {};
  modality = '';
  audioLevel = 0;
  public isAlertActive = false;
  public alertActiveSubscription: Subscription;
  public selectedTab = '';
  openDocumentsAdd = false;
  // Scroll-to-switch-tab: overscroll accumulated at the page edge drives the hint pill;
  // pageAnim is the slide-out / slide-in class on the page while switching.
  edgeHint: { dir: 'next' | 'prev'; label: string; progress: number } | null = null;
  pageAnim: '' | 'out-next' | 'out-prev' | 'in-next' | 'in-prev' = '';
  private edgeScroll = 0;
  private edgeHintTimer: ReturnType<typeof setTimeout>;
  private pageAnimTimer: ReturnType<typeof setTimeout>;

  public shouldTranslateSub: Subscription;
  public shouldTranslate = true;

  public showTranscription: boolean = false;

  constructor(
    private location: Location,
    private patservice: PatientsService,
    public vs: VideoCaptureService,
    private vidClient: VideoClientService,
    public ps: PregnancyService,
    public atS: AutotextService,
    private sanitizer: DomSanitizer,
    public ls: LoginService,
    private router: Router,
    public ts: TimerService,
    public gs: GalleryService,
    public es: ExamsService,
    public languageService: LanguageService,
    private examsbarService: ExamsbarService,
    private dialog: MatDialog
  ) {
    this.es.loginMissing();
    this.vidMinified = false;
    this.audioInputs = [];
    this.videoInputs = [];
    this.gs.isOpen = false;
    this.ExamSubscription = this.es.examLoaded$.subscribe(async () => {
      if (!this.es.isClosed) {
        this.exitTimeout = setTimeout(
          () => {
            this.exit();
          },
          120 * 60 * 1000
        );
      } else {
        if (this.es.ExamType != 'Emergency Room') {
          this.showprintopts = false;
          this.showprint = true;
        }
      }
      if (
        this.es.ExamType != 'Follicles' &&
        this.es.ExamType != 'Gynecology' &&
        this.patservice.getPat().ID != 'default' &&
        !this.es.isForm
      )
        this.ps.setExamID(this.es.examID, this.es.CreationTime);
      this.sendonce = this.es.LinkSent;
    });
  }

  async ngOnInit() {
    if (
      (this.ls.usMode || this.ls.premissions?.usMode) &&
      this.es.examsUsMode.includes(this.es.ExamType)
    ) {
      await this.es.fetchModality();
      if (this.es.isClosed) {
        this.modality = this.es.modality;
      }
      if (!this.es.isClosed && !this.es.modality) {
        this.es.saveVals('Modality', 'Ultrasound', true, 'exams');
        this.es.modality = 'Ultrasound';
      }
      if (!this.es.isClosed) {
        this.modality = this.es.modality;
      }
    }

    this.getCountLinks();
    this.pat = this.patservice.getPat();
    //this.recordLink = this.sanitizer.bypassSecurityTrustUrl('ArtisanImage:Start' + this.es.examID);
    this.es.ShowSRs = false;

    // ── Subscribe to app-level examsbar events ────────────────────────
    this.examsbarService.pageChange$
      .pipe(takeUntil(this.examDestroy$))
      .subscribe((pg) => this.setPage(pg));
    this.examsbarService.showPatDetails$
      .pipe(takeUntil(this.examDestroy$))
      .subscribe(() => (this.showPat = true));
    // ──────────────────────────────────────────────────────────────────

    // this.cookie=this.cookieServ.get('connect.sid');
    if (this.pat.ID == 'default') this.page = 'Placenta';
    if ((this.es.ExamType != 'Follicles' && this.es.ExamType == 'Gynecology') || this.ls.isCardio)
      this.page = 'Introduction';
    if (this.es.ExamType == 'Emergency Room') this.page = null;
    if (this.es.isForm) this.page = 'forms';
    if (this.es.ExamType === 'Pediatric Echo') {
      this.page = 'Anamnesis';
    }
    if (
      this.ls.Recording == 'webrtc' &&
      !this.ls.RemoteRTC &&
      this.pat.ID != 'default' &&
      !this.es.isForm &&
      this.es.ExamType != 'Emergency Room' &&
      !this.es.isClosed
    ) {
      const inputs = await this.vs.getDevices();
      this.videoInputs = inputs.video;
      this.audioInputs = inputs.audio;
      try {
        const oldv = window.localStorage.getItem('video');
        if (
          oldv &&
          this.videoInputs.find((item) => {
            return item.value == oldv;
          })
        ) {
          this.videoSource = oldv;
        }
        const olda = window.localStorage.getItem('audio');
        if (
          olda &&
          this.audioInputs.find((item) => {
            return item.value == olda;
          })
        ) {
          this.audioSource = olda;
        }
        await this.startVideo();
        if (this.ls.hasImaging && this.es.ExamType == 'Gynecology') {
          this.vs.ExamID = this.es.examID;
          this.vs.openWebSocket(); //for image capture messages
        }
        this.vs._photoS.subscribe((photo) => {
          this.imageCanvas.nativeElement.width = photo.width;
          this.imageCanvas.nativeElement.height = photo.height;
          this.imageCanvas.nativeElement.getContext('2d').drawImage(photo, 0, 0);
          this.imageCanvas.nativeElement.style.display = 'block';
          try {
            if (this.showTimmer) clearTimeout(this.showTimmer);
          } catch (e) {
            console.log(e);
          }
          this.showTimmer = setTimeout(() => {
            this.imageCanvas.nativeElement.style.display = 'none';
          }, 3000);
        });
      } catch (e) {
        console.log(e);
      }
    }
    if (this.ls.RemoteRTC && !this.es.isClosed) {
      this.vidClient.GotStream.subscribe(() => {
        this.Stream = this.vidClient.Stream;
      });
      this.vidClient.ConnectServer();
    }

    this.shouldTranslateSub = this.es.shouldTranslate$.subscribe((data) => {
      this.shouldTranslate = data;
    });

    this.sub = this.es.titleChange.subscribe((res) => {
      this.es.changedTitle = res;
      if (res) {
      }
    });

    if (
      this.ls.premissions?.Consent &&
      this.es.ExamType !== 'Pediatric Echo' &&
      this.es.ExamType !== 'Gynecology ' &&
      this.pat.ID != 'default'
    ) {
      setTimeout(() => {
        this.es.getConcentForExam().subscribe((data) => {
          this.linkedConcent = data;
        });
      }, 600);
    }
  }

  ngAfterViewInit() {
    // Get access to the microphone audio stream
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        this.videoElement.nativeElement.srcObject = stream;

        // Create an audio context and analyzer
        const audioContext = new AudioContext();
        const analyzer = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);

        microphone.connect(analyzer);

        // Continuously update audio level
        const updateAudioLevel = () => {
          const dataArray = new Uint8Array(analyzer.frequencyBinCount);
          analyzer.getByteFrequencyData(dataArray);
          const average = dataArray.reduce((acc, val) => acc + val, 0) / dataArray.length;
          this.audioLevel = Math.floor((average / 255) * 100); // Convert to 0-100 scale
          requestAnimationFrame(updateAudioLevel);
        };

        audioContext.resume().then(() => {
          updateAudioLevel(); // Start updating audio level
        });
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
      });
  }

  openReferral() {
    const pat = this.patservice.getPat();
    this.dialog.open(BloodTestReferralDialogComponent, {
      data: {
        PID: pat.PID ? pat.PID.toString() : pat.ID,
        GID: this.ls.ClinicID,
        patientName: (pat.First || '') + ' ' + (pat.Last || ''),
        patientID: pat.ID,
        patientDOB: pat.Birth,
        HMO: pat.HMO || '',
        examID: this.es.examID
      },
      width: '1150px',
      height: '820px'
    });
  }

  openPrescription() {
    const pat = this.patservice.getPat();
    this.dialog.open(PrescriptionDialogComponent, {
      data: {
        PID: pat.PID ? pat.PID.toString() : pat.ID,
        GID: this.ls.ClinicID,
        patientName: (pat.First || '') + ' ' + (pat.Last || ''),
        patientID: pat.ID,
        patientDOB: pat.Birth,
        HMO: pat.HMO || '',
        examID: this.es.examID
      },
      width: '980px',
      height: '700px'
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.exitTimeout) {
      clearTimeout(this.exitTimeout);
    }
    if (this.ls.RemoteRTC) this.vidClient.StopRecording();
    else {
      this.vs.Clean();
      this.vs.closeWebSocket();
    }
    // this.es.exitExam();
    this.ExamSubscription.unsubscribe();
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.takePicSubsctiption) {
      this.takePicSubsctiption.unsubscribe();
    }
    if (this.shouldTranslateSub) {
      this.shouldTranslateSub.unsubscribe();
    }
    clearTimeout(this.edgeHintTimer);
    clearTimeout(this.pageAnimTimer);
    this.examDestroy$.next();
    this.examDestroy$.complete();
  }

  // Scrolling past the bottom (top) of the current page moves to the next (previous) tab,
  // in addition to clicking the tabs. While the user keeps scrolling at the edge a pill with the
  // next tab's name fills up; when full, the page slides out and the next one slides in.
  // Stopping early lets the pill fade away with nothing changed.
  @HostListener('window:wheel', ['$event'])
  onWheel(e: WheelEvent) {
    if (!this.ls.aweb3('Aweb3ScrollTabs')) return;
    if (e.ctrlKey || !e.deltaY || !this.page || this.pageAnim || this.scrollNavBlocked()) return;
    if (this.innerScrollable(e.target as HTMLElement, e.deltaY)) return;

    const doc = document.scrollingElement || document.documentElement;
    const dir = e.deltaY > 0 ? 'next' : 'prev';
    const atEdge =
      dir === 'next'
        ? doc.scrollTop + window.innerHeight >= doc.scrollHeight - 2
        : doc.scrollTop <= 0;
    const target = atEdge ? this.examsbarService.neighbor(dir) : null;
    if (!target) return this.clearEdgeHint();

    if (this.edgeHint?.dir !== dir) this.edgeScroll = 0;
    this.edgeScroll += Math.abs(e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY);
    const progress = Math.min(1, this.edgeScroll / 300);
    this.edgeHint = { dir, label: target.label, progress };

    clearTimeout(this.edgeHintTimer);
    if (progress < 1) {
      this.edgeHintTimer = setTimeout(() => this.clearEdgeHint(), 700);
      return;
    }

    this.pageAnim = dir === 'next' ? 'out-next' : 'out-prev';
    this.pageAnimTimer = setTimeout(() => {
      const before = this.page;
      this.examsbarService.scrollNav$.next(dir);
      this.clearEdgeHint();
      if (this.page === before) {
        this.pageAnim = ''; // blocked (e.g. the Defaults / missing LMP popup opened)
        return;
      }
      this.pageAnim = dir === 'next' ? 'in-next' : 'in-prev';
      window.scrollTo({ top: 0, behavior: 'instant' });
      if (dir === 'prev') {
        setTimeout(() => window.scrollTo({ top: doc.scrollHeight, behavior: 'instant' }));
      }
      this.pageAnimTimer = setTimeout(() => (this.pageAnim = ''), 350);
    }, 180);
  }

  private clearEdgeHint() {
    clearTimeout(this.edgeHintTimer);
    this.edgeHint = null;
    this.edgeScroll = 0;
  }

  // Popups / dialogs are open — don't switch the page underneath them.
  private scrollNavBlocked(): boolean {
    return (
      this.defaultWarn ||
      this.missingLMPMsg ||
      this.showPat ||
      this.showgallery ||
      this.showprint ||
      this.showcharts ||
      this.showInbox ||
      this.showlink ||
      this.showPrintHistory ||
      this.inform ||
      !!document.querySelector('.cdk-overlay-container .cdk-overlay-pane')
    );
  }

  // True when the wheel is over an inner scroll box (textarea, list, etc.) that can still scroll that way.
  private innerScrollable(el: HTMLElement | null, deltaY: number): boolean {
    for (; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (el.scrollHeight <= el.clientHeight) continue;
      const oy = getComputedStyle(el).overflowY;
      if (oy !== 'auto' && oy !== 'scroll') continue;
      const canScroll =
        deltaY > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0;
      if (canScroll) return true;
    }
    return false;
  }

  setPage(pg: string) {
    if (this.es.showDefaultButton()) {
      this.afterdefault = pg;
      this.defaultWarn = true;
    } else if (this.es.showMissingLMPMsg(pg) && this.pat.ID !== 'default') {
      this.missingLMPMsg = true;
      this.selectedTab = pg;
    } else {
      this.page = pg;
    }
  }

  noDefaults() {
    this.es.saveVals('EDefault', 1, true, 'exams');
    this.es.Defaults = 1;
    this.page = this.afterdefault;
    this.defaultWarn = false;
  }

  cancelDefaultQ() {
    this.defaultWarn = false;
    this.examsbarService.switchPage$.next(
      this.es.ExamType == 'Gynecology' ? 'Gynecology' : 'Pregnancy'
    );
  }

  missingLMPContinue() {
    this.es.shouldAutoFocus = false;
    this.es.shouldAutoFocus$.next(false);
    this.missingLMPMsg = false;
    this.page = this.selectedTab;
  }

  backToPregnancy() {
    this.missingLMPMsg = false;
    this.es.shouldAutoFocus = true;
    this.es.shouldAutoFocus$.next(true);
    this.examsbarService.switchPage$.next(
      this.es.ExamType === 'Gynecology' ? 'Gynecology' : 'Pregnancy'
    );
    this.page = this.es.ExamType === 'Gynecology' ? 'Gynecology' : 'Pregnancy';
  }

  startForm() {
    this.es.ps.resetPreg();
    let temp = this.es.pregnancies.filter((i) => i.AutoIndex == this.es.ps.pregID);
    if (temp.length > 0) {
      // var res = this.es.getConcentForms();
      // res.subscribe((data) =>{
      //   temp = data
      // })
      temp = temp[0].forms.filter(
        (i) => i.ExamID == this.es.examID || (!i.ExamID && i.ExamType == this.es.ExamType)
      );
    }
    if (temp.length > 0) this.concentForm = temp[0];
    else this.concentForm = null;

    this.inform = true;
  }

  changeFetuses(n: number) {
    this.fetuses = n;
  }

  record() {
    if (this.ls.RemoteRTC && !this.noStop) {
      this.noStop = true; //don't allow to stop recording in less than 5 secons
      if (this.vidClient.Recording) {
        this.vidClient.StopRecording();
      } else if (!this.vidClient.Recording) {
        this.vidClient.StartRecording();
      }
      setTimeout(() => {
        this.noStop = false;
      }, 5000);
    } else {
      if (!this.noStop) {
        this.noStop = true;
        this.vs.Record(this.es.examID);
        setTimeout(() => {
          this.noStop = false;
        }, 2000);
      }
    }
  }

  isRecording(): boolean {
    if (this.ls.RemoteRTC) return this.vidClient.Recording;
    else return this.vs.recording;
  }

  openGallery(inbox: number) {
    this.CurrentInbox = inbox;
    this.showgallery = true;
  }

  async startVideo() {
    this.Stream = await this.vs.startVideo(this.videoSource, this.audioSource, this.soundtest);
  }

  loadSR(sr: number) {
    this.CurrentSR = sr;
    this.es.getSR(sr).subscribe(
      (data) => {
        this.SR = this.sanitizer.sanitize(SecurityContext.HTML, data);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  exit(patlist = false) {
    this.es.exitExam();
    if (this.ls.isCardio && this.ls.userType == 'secretary') {
      this.location.back();
    } else {
      this.router.navigateByUrl(patlist ? '/patsearch' : '/exams');
    }
  }

  maximizeVid() {
    this.videoElement.nativeElement.requestFullscreen();
  }

  handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
  }

  togglefullscreen() {
    this.fullscreen = !this.fullscreen;
  }

  deleteMedia() {
    this.gs.delete();
    this.showgallery = false;
    this.showdeleteimg = false;
    setTimeout(() => {
      this.showgallery = true;
    }, 100);
  }

  getDisk() {
    if (this.messages == 'Creating Disk ...') return;
    this.messages = 'Creating Disk ...';
    this.es.getDisk().subscribe(
      (data) => {
        this.messages = 'Downloading disk';
        setTimeout(() => {
          this.messages = 'When buring disk or onkey ignore the "Not Responding" message';
          setTimeout(() => {
            this.messages = null;
          }, 10000);
        }, 2000);
        const element = document.createElement('a');
        element.setAttribute('href', '/api/readydisk/' + data['disknum'] + '/' + data['disk']);
        element.setAttribute('download', data['disk']);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        //window.location.href = '/api/readydisk/' + data['disknum'] + '/' + data['disk'];
      },
      (err) => {
        this.messages = 'Disk Creation failed';
        setTimeout(() => {
          this.messages = null;
        }, 3000);
      }
    );
  }

  closeConcent(event) {
    console.log(event);
    this.inform = false;
  }

  getCountLinks() {
    this.ls.countLinks();
  }

  checkApprovedConcent(consent: any) {
    let valid = false;
    if (
      consent.approved &&
      consent.approved !== 'appotropus' &&
      consent.patSign &&
      consent.patSignApproved &&
      consent.docSign
    ) {
      valid = true;
    } else if (
      consent.approved &&
      consent.approved === 'appotropus' &&
      consent.patSign &&
      consent.docSign
    ) {
      valid = true;
    }
    return valid;
  }

  async changeModality() {
    if (this.es.isClosed) return;
    this.es.saveVals('Modality', this.modality, true, 'exams');
    this.es.modality = this.modality;
  }
}
